import { useState } from 'react';
import { useDashboardFeatureFlags } from '@components';
import { useDashboardStorage } from '@hooks/useDashboardStorage';
export const useContinueBarVisibility = () => {
    const { dashboardStorage } = useDashboardStorage();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const [visible, setVisible] = useState(!!dashboardStorage.get('launchStrategy.continueBar'));
    const isEnabled = dashboardFeatureFlags.launchStrategy.enabled;
    const handleSetVisible = (isVisible) => {
        dashboardStorage.set('launchStrategy.continueBar', isVisible);
        setVisible(isVisible);
    };
    return {
        visible: isEnabled && visible,
        setVisible: handleSetVisible,
    };
};
